import { useAppData } from '@hellodarwin/core/lib/features/providers/app-data-provider';
import { useEffect, useRef, useState } from 'react';
const useSidebarManager = () => {
    const { navCollapsed, setNavCollapsed } = useAppData();
    const [ignoreNextNavChange, setIgnoreNextNavChange] = useState(false);
    const hasNavChangedRef = useRef(false);
    const initialNavCollapsedRef = useRef(undefined);
    useEffect(() => {
        if (initialNavCollapsedRef.current !== undefined &&
            initialNavCollapsedRef.current !== navCollapsed &&
            !ignoreNextNavChange) {
            hasNavChangedRef.current = true;
        }
        setIgnoreNextNavChange(false);
    }, [navCollapsed]);
    useEffect(() => {
        initialNavCollapsedRef.current = navCollapsed;
        if (navCollapsed != null && !navCollapsed) {
            setIgnoreNextNavChange(true);
            setNavCollapsed(true);
        }
        return () => {
            if (!hasNavChangedRef.current &&
                initialNavCollapsedRef.current !== undefined) {
                setNavCollapsed(initialNavCollapsedRef.current);
            }
        };
    }, []);
};
export default useSidebarManager;
